import { useLayoutEffect, useRef } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';
import { scroll_inst } from '../../utils';

const WORK_LIST_PATH_PATTERN = /^\/OurWork\/?$/i;
const WORK_DETAIL_PATH_PATTERN = /^\/OurWork\/[^/]+\/?$/i;

const ScrollToTop = () => {
    const { pathname, search } = useLocation();
    const navigationType = useNavigationType();
    const scrollPositionsRef = useRef(new Map());
    const previousPathnameRef = useRef(pathname);

    const getCurrentScrollTop = () => {
        const overlayPosition = scroll_inst?.scroll?.()?.position?.y;
        if (typeof overlayPosition === 'number') return overlayPosition;

        const viewport = scroll_inst?.getElements?.()?.viewport;
        if (viewport) return viewport.scrollTop;

        return window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
    };

    const scrollToPosition = (position) => {
        let usedOverlayScroll = false;

        if (scroll_inst?.scroll) {
            scroll_inst.scroll(position, 0);
            usedOverlayScroll = true;
        }

        const viewport = scroll_inst?.getElements?.()?.viewport;
        if (viewport) {
            viewport.scrollTop = position;
            usedOverlayScroll = true;
        }

        if (!usedOverlayScroll) {
            window.scrollTo(0, position);
            document.documentElement.scrollTop = position;
            document.body.scrollTop = position;
        }
    };

    // Restore scroll only when returning to /OurWork from an /OurWork/:slug detail via browser back.
    // In all other navigations, start at the top.
    useLayoutEffect(() => {
        const routeKey = `${pathname}${search}`;
        const scrollPositions = scrollPositionsRef.current;
        const previousPathname = previousPathnameRef.current;
        const isWorkListRoute = WORK_LIST_PATH_PATTERN.test(pathname);
        const cameFromWorkDetail = WORK_DETAIL_PATH_PATTERN.test(previousPathname);
        const shouldRestoreWorkList =
            isWorkListRoute &&
            cameFromWorkDetail &&
            navigationType === 'POP' &&
            scrollPositions.has(routeKey);

        if (shouldRestoreWorkList) {
            scrollToPosition(scrollPositions.get(routeKey));
        } else {
            scrollToPosition(0);
        }

        previousPathnameRef.current = pathname;

        return () => {
            scrollPositions.set(routeKey, getCurrentScrollTop());
        };
    }, [pathname, search, navigationType]);

    return null;
};

export default ScrollToTop;
